import { createContext } from "react";

// Slot for views (currently CallDetailView) to portal extra content
// into the App-level Sidebar so it visually lives inside the dark
// sidebar column below the bottom nav items.
export const SidebarSlotContext = createContext<HTMLDivElement | null>(null);
